import React from 'react';

import { Box } from '@/shared/ui/box';
import { Button } from '@/shared/ui/form/button';
import BurnWarningIcon from '@/shared/assets/burn-warning.svg';
import { formatCurrency } from '@/shared/libs/format-currency';
import {
  BodyTextBoldSecondary,
  BodyTextRegularSecondary,
  BodyTextRegularTertiary,
  BoldHeadingQuaternary,
  BoldHeadingSenary,
} from '@/shared/ui/typography';

import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import * as Dialog from '@radix-ui/react-dialog';

import { generateBg } from '@/flat-pages/bonuses/model/utils';

import {
  StyledAlertDialogOverlay,
  StyledAlertDialogContent,
  AuthCloseIconImage,
} from '@/features/auth-managment/styles';

import {
  BonusDetails,
  BonusDialogContent,
  BurnWarningWrapper,
  DetailItem,
  DetailItems,
} from '../../styles';

import { BonusItemBurns } from './styles';

export const BonusBurnModal = ({
  visible,
  onClose,
  bonus,
  progressWager,
  notifications,
  user,
  t,
  onDeactivate,
}) => {
  return (
    <Dialog.Root open={visible} onOpenChange={onClose}>
      <Dialog.Portal>
        <StyledAlertDialogOverlay onClick={onClose} />
        <StyledAlertDialogContent>
          <BonusDialogContent>
            <BonusItemBurns $generateBg={generateBg(bonus)}>
              <BonusDetails style={{ marginBottom: 0 }}>
                <VisuallyHidden>
                  <Dialog.Title>bonuce delete</Dialog.Title>
                </VisuallyHidden>
                <Box onClick={onClose}>
                  <AuthCloseIconImage
                    width={32}
                    height={32}
                    src="/images/icons/close-dialog.svg"
                    alt="Close dialog"
                  />
                </Box>
                <Box $marginTop={24} $marginBottom={24}>
                  <BurnWarningWrapper>
                    <BurnWarningIcon />
                  </BurnWarningWrapper>
                </Box>
                <Box $textAlign="center">
                  <BoldHeadingQuaternary>
                    {t('burn_modal.title')}
                  </BoldHeadingQuaternary>
                </Box>
                <Box $textAlign="center" $marginTop={8} $marginBottom={12}>
                  <BodyTextRegularSecondary color="#AFAFAF">
                    {t('burn_modal.desc2')}:
                  </BodyTextRegularSecondary>
                </Box>
                <Box></Box>
                <DetailItems>
                  <DetailItem>
                    <BodyTextRegularTertiary color="#AEB8D1">
                      {t('burn_modal.bonus_balance')}
                    </BodyTextRegularTertiary>
                    <BoldHeadingSenary>
                      {formatCurrency(notifications?.bonus?.bonusBalance, {
                        currency: user?.currency,
                        currencySymbol: user?.currencySymbol,
                      })}
                    </BoldHeadingSenary>
                  </DetailItem>
                  <DetailItem>
                    <BodyTextRegularTertiary color="#AEB8D1">
                      {t('burn_modal.wager_progress')}
                    </BodyTextRegularTertiary>
                    <BoldHeadingSenary>
                      {Number(progressWager).toFixed(2)}
                    </BoldHeadingSenary>
                  </DetailItem>
                </DetailItems>
                <Box $marginTop={24} $display="flex" $gap={5}>
                  <Button
                    type="button"
                    onClick={() => onDeactivate(bonus)}
                    fill
                    variant="danger"
                  >
                    <Box>
                      <BodyTextBoldSecondary>
                        {t('card.button_burn')}
                      </BodyTextBoldSecondary>
                    </Box>
                  </Button>
                  <Button type="button" onClick={onClose} fill variant="gray">
                    <Box>
                      <BodyTextBoldSecondary>
                        {t('burn_modal.button_close')}
                      </BodyTextBoldSecondary>
                    </Box>
                  </Button>
                </Box>
              </BonusDetails>
            </BonusItemBurns>
          </BonusDialogContent>
        </StyledAlertDialogContent>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
